//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WordStudyChip from '@/components/innovation/WordStudyChip.vue'
export default {
  components: { WordStudyChip },
  data () {
    return { dialogues: [], bank: [], words: [], fills: [], used: {}, start: Date.now() }
  },
  created () {
    this.$ajax.get(this.$api.cpPuzzleStart + '?scene_id=' + this.$route.query.id).then(r => {
      this.dialogues = (r && r.dialogues) || []
      this.bank = (r && r.word_bank) || []
      this.words = (r && r.words) || []
      this.fills = this.words.map(() => '')
    }).catch(e => { this.$toast && this.$toast(e.message || '无法开始') })
  },
  methods: {
    shortMean (w) {
      const m = w.meaning || w.hint || ''
      return String(m).slice(0, 24)
    },
    fillLine (d) {
      return (d.contentEn || d.content_en || '').replace('___', '____')
    },
    pick (w) {
      if (this.used[w]) return
      const idx = this.fills.findIndex(x => !x)
      if (idx < 0) return
      this.$set(this.fills, idx, w)
      this.$set(this.used, w, true)
    },
    unfill (i) {
      const w = this.fills[i]
      if (!w) return
      this.$set(this.fills, i, '')
      this.$set(this.used, w, false)
    },
    finish () {
      this.$ajax.post(this.$api.cpPuzzleFinish, {
        scene_id: this.$route.query.id,
        answers: this.fills,
        duration: Math.round((Date.now() - this.start) / 1000)
      }).then(r => {
        this.$router.replace({ path: '/cpResult_display', query: { record_id: r.record_id, scene_id: this.$route.query.id } })
      }).catch(e => { this.$toast && this.$toast(e.message || '提交失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/context-puzzle/puzzle.vue